import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { BookingListElementBookingFragmentDoc } from './BookingListElement.generated';
export type BookingListBookingConnectionFragment = { __typename?: 'BookingConnection', pageInfo: { __typename?: 'BookingPageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'BookingEdge', node: { __typename?: 'Booking', guid: string, startsAt: TimeString, endsAt: TimeString, cancelReason?: Types.BookingCancelReason | null, summary?: string | null, assignedStaff: { __typename?: 'Staff', displayName: string } } }> };

export const BookingListBookingConnectionFragmentDoc = gql`
    fragment BookingListBookingConnection on BookingConnection {
  pageInfo {
    hasNextPage
    endCursor
  }
  edges {
    node {
      ...BookingListElementBooking
    }
  }
}
    ${BookingListElementBookingFragmentDoc}`;